import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";

const FactoryAutomationVideoCard_5 = () => {
  return (
    <div className="card w-50 h-auto">
      <div className="card-body bg-dark text-white">
        <h5 className="card-title">Cobot for Belco</h5>
        <p className="card-text">
        Although this project was very simple from a technical point of view, 
        breaking the paradigm was quite a challenge, since it was the first 
        Cobot implemented in the plant.
        </p>

        <h6>
          Investment: <span>$23,700,000 USD</span>
        </h6>
        <h6>
          Time to build: <span>3 months</span>
        </h6>
        <h6>
          Savings: <span>3 DL were re-located</span>
        </h6>
        <h6>
          Technology:
          <span>
            UR Cobot.
          </span>
        </h6>
      </div>
    </div>
  );
};

export default FactoryAutomationVideoCard_5;
